import { Component, Input, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { Administrator } from '../../models/administrator';
import { HealthOrganizationUser } from '../../models/healthOrganizationUser';

@Component({
  selector: 'app-user-assign',
  templateUrl: './user-assign.component.html',
  styleUrls: ['./user-assign.component.scss']
})
export class UserAssignComponent implements OnInit {
  @Input() healthOrgId: number;
  users:Administrator[]=[];
  selectedusers:number[]=[];

  constructor(private userService :UserService,private practiceService:PracticeService) { }

  ngOnInit() {
    
    let apicallOne = this.userService.getUsersByRoleCategory("AHI");
    let apiCallTwo = this.practiceService.getUsersByHealthOrganizationId(this.healthOrgId);

    forkJoin([apicallOne, apiCallTwo]).subscribe(results => {     
      this.users = results[0] ;
      this.selectedusers=results[1].result;
      this.users.forEach(element => {
        element.IsAssigned=this.selectedusers.includes(element.id);
      });
      
    });
  }
  onCheckChange(event,administrator:Administrator){
    console.log(event.checked);
    let temphealthOrganizationUser=new HealthOrganizationUser();
    temphealthOrganizationUser.UserId=administrator.id;
    temphealthOrganizationUser.IsAssigned=event.checked;
    this.practiceService.mapUserToHealthOrganization(this.healthOrgId,temphealthOrganizationUser).subscribe(result=>{
    })
   }
}
